import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';

import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import Panel from 'react-bootstrap/lib/Panel';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import SelectFieldComponent from '../../Common/FormField/SelectFieldComponent';

import { getCurrencySymbol } from '../../../helpers/currencyConvertion';
import s from './ServiceFeesForm.css';
import bt from '../../../components/commonStyle.css';

class ServiceFeesForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
    base: PropTypes.string.isRequired,
    availableCurrencies: PropTypes.arrayOf(PropTypes.shape({
      symbol: PropTypes.string.isRequired
    })).isRequired
  };


  render() {
    const { formatMessage } = this.props.intl;
    const { error, handleSubmit, submitting, dispatch, initialValues, currentLocale, currency } = this.props;
    const { base, availableCurrencies, guestType, hostType } = this.props;
    let symbol = getCurrencySymbol(currency, currentLocale);


    let currenciesValue = [
      { value: '', label: formatMessage(messages.chooseCurrency) }
    ]

    availableCurrencies?.length > 0 && availableCurrencies.map((currency, key) => {
      if (currency.isEnable === true) {
        currenciesValue.push({
          value: currency.symbol,
          label: currency.symbol
        })
      }
    })
    return (
      <Grid fluid className='adminRadioBtn'>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.manageServiceFee} /></h1>
          </Col>
          <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{formatMessage(error)}</strong>}
                <FormGroup className={bt.space4}>
                  <label className={s.labelTextNew}><FormattedMessage {...messages.guestFeeType} /></label>
                  <div className='commonRadioBtnFlexGroup'>
                    <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                      <Field name="guestType"
                        component="input"
                        type="radio" value="fixed" />
                      <span className={s.radioBtn}><FormattedMessage {...messages.fixedPrice} /></span>
                    </label>

                    <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                      <Field name="guestType"
                        component="input"
                        type="radio"
                        value="percentage" />
                      <span className={s.radioBtn}><FormattedMessage {...messages.percentage} /></span>
                    </label>
                  </div>
                </FormGroup>

                <Field
                  name="guestValue"
                  type="text"
                  isAddon={true}
                  prefixLabel={guestType == 'fixed' ? symbol : '%'}
                  component={InputFieldComponent}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                  label={formatMessage(messages.guestServiceFee)}
                  placeholder={formatMessage(messages.guestServiceFee)}
                />

                <FormGroup className={bt.space3}>
                  <label className={s.labelTextNew}><FormattedMessage {...messages.hostFeeType} /></label>
                  <div className='commonRadioBtnFlexGroup'>
                    <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                      <Field name="hostType" component="input" type="radio" value="fixed" />
                      <span className={s.radioBtn}><FormattedMessage {...messages.fixedPrice} /> </span></label>
                    <label className={cx(s.labelTextNew, bt.cursorPointer, 'commonRadioFlex')}>
                      <Field name="hostType" component="input" type="radio" value="percentage" />
                      <span className={s.radioBtn}><FormattedMessage {...messages.percentage} /></span> </label>
                  </div>
                </FormGroup>

                <Field name="hostValue"
                  type="text"
                  isAddon={true}
                  prefixLabel={hostType == 'fixed' ? symbol : '%'}
                  component={InputFieldComponent}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                  label={formatMessage(messages.hostServiceFeeType)}
                  placeholder={formatMessage(messages.hostServiceFeeType)}
                />

                <Field name="currency"
                  type='text'
                  inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                  component={SelectFieldComponent}
                  label={formatMessage(messages.currency)}
                  options={currenciesValue}
                  formGroupClass={bt.space4}
                />
                <div className='singleButtonFlexEnd'>
                  <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting} >
                    <FormattedMessage {...messages.save} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }

}

ServiceFeesForm = reduxForm({
  form: 'ServiceFeesForm', // a unique name for this form
  validate
})(ServiceFeesForm);

const selector = formValueSelector('ServiceFeesForm'); // <-- same as form name

const mapState = (state) => ({
  availableCurrencies: state?.currency?.availableCurrencies?.results,
  base: state.currency.base,
  currentLocale: state.intl.locale,
  currency: selector(state, 'currency'),
  guestType: selector(state, 'guestType'),
  hostType: selector(state, 'hostType'),

});

const mapDispatch = {
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ServiceFeesForm)));